import { humanizeWireValue } from 'syft-acp-core/components/SchedulingPlanDialog'
import type { AgencyJobHistoryEntry } from 'syft-acp-core/store/agency-jobs-history/types'

type TagStatus = 'info' | 'warning' | 'neutral'

// flex-core's AgencyJob::ALLOCATION_STATUS. A status added there later falls back to a readable form
// of the raw value.
const knownStatuses: Record<string, { label: string; tagStatus: TagStatus }> = {
  active: { label: 'Active', tagStatus: 'info' },
  action_needed: { label: 'Action needed', tagStatus: 'warning' },
  partially_cascaded: { label: 'Partially cascaded', tagStatus: 'warning' },
  cascaded: { label: 'Cascaded', tagStatus: 'warning' },
  removed: { label: 'Removed', tagStatus: 'neutral' },
  declined: { label: 'Declined', tagStatus: 'neutral' },
}

export const getAgencyJobStatusTag = (status: string): { label: string; tagStatus: TagStatus } =>
  knownStatuses[status] ?? { label: humanizeWireValue(status), tagStatus: 'neutral' }

/** Live means neither declined nor ended, read from the timestamps rather than the status. */
export const isLiveAgencyJob = (agencyJob: AgencyJobHistoryEntry) =>
  !agencyJob.declined_at && !agencyJob.ended_at

export const formatShiftCount = (count: number) => `${count} shift${count === 1 ? '' : 's'}`

export const formatAgencyRank = (rank: number | null) => (rank === null ? 'Unranked' : `Rank ${rank}`)
